'use client'
import { useState } from 'react'
import { PrismicRichText } from '@prismicio/react'
import InfoIcon from '@/assets/images/icons/info-icon-roadmap.svg'

interface InfoTileProps {
    open: any | null;
    info: any | null
}

const InfoTile: React.FC<InfoTileProps> = ({ open, info }) => {
  const [openState, setOpenState] = useState(open === 0 ? true : false)
  
  return (
      <div className='text-[14px]'>
        <p onClick={()=>setOpenState(!openState)} className="pb-4"><InfoIcon /></p>
        {openState === true ?
          <PrismicRichText field={info}/>
        :<></>}
      </div>
  )
}

export default InfoTile;

